/**
 * Matchmaking strategy declared on match config entries.
 * MMS queue workers dispatch tickets by this value.
 */
export enum MatchmakingStrategy {
  IMMEDIATE_LOBBY_MATCH = 'immediate_lobby_match',
  QUEUED_TEAM_MATCH = 'queued_team_match'
}

export const DEFAULT_MAX_QUEUE_TIME_MS = 60 * 1000;

/**
 * Placeholder for future per-map scope policies. MMS currently only supports
 * class-scoped matching through its existing global scope grouping behavior;
 * map-level scope policies will be implemented when additional policies exist.
 */
export type MatchmakingScopePolicy = 'configured_scope' | 'prefer_class_during_school_hours';

export interface IMatchmakingConfig {
  strategy: MatchmakingStrategy;
  maxQueueTimeMs?: number;
  scopePolicy?: MatchmakingScopePolicy;
}

/** GES-side match prep options declared on match config entries. */
export interface IEnginePrepConfig {
  fillEmptySlotsWithAi?: boolean;
}

export function isMatchmakingStrategy(value: unknown): value is MatchmakingStrategy {
  return value === MatchmakingStrategy.IMMEDIATE_LOBBY_MATCH
    || value === MatchmakingStrategy.QUEUED_TEAM_MATCH;
}
